var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-view"},_vm._l((_vm.allOffers),function(offer){return _c('v-col',{key:offer.id,staticStyle:{"width":"300px"}},[_c('offer-card',{attrs:{"offer":offer}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }